import script from "./CourseAdvantages.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseAdvantages.vue?vue&type=script&setup=true&lang=js"

import "./CourseAdvantages.vue?vue&type=style&index=0&id=e2697430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2697430"]])

export default __exports__